"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartPopup = void 0;
const cart_reducer_1 = require("@app/store/reducers/cart.reducer");
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const currency_label_1 = require("@components/currency-label");
const stub_cards_1 = require("@components/stub-cards");
const routing_hooks_1 = require("@hooks/routing.hooks");
const token_hooks_1 = require("@hooks/token.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
const button_1 = require("@shared-modules/components/button");
const icons_1 = require("@shared-modules/components/icons");
const loader_1 = require("@shared-modules/components/loader");
const popup_1 = require("@shared-modules/components/popup");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const recipe_form_1 = require("./components/recipe-form");
require("./styles.scss");
const CartPopup = (props) => {
    const cart = (0, cart_reducer_1.useCart)();
    const initialCart = (0, react_1.useRef)(structuredClone(cart));
    const { list: tokenList, isLoading, isFirstLoadCompleted, } = (0, token_hooks_1.useTokenListByFilter)({ tokenIds: initialCart.current }, { size: initialCart.current.length });
    const actualTokens = tokenList.filter(({ tokenId, type }) => cart.includes(tokenId) && type === "market");
    const unavailableTokens = tokenList.filter(({ tokenId, type }) => cart.includes(tokenId) && type !== "market");
    const hiddenTokens = isFirstLoadCompleted
        ? cart.filter((tokenId) => !tokenList.some((token) => token.tokenId === tokenId))
        : [];
    const translator = (0, translation_hooks_1.useComponentTranslation)("cartPopup");
    const tokenGetter = (0, tokens_reducer_1.useTokenGetter)();
    const togglePopupVisibility = (0, cart_reducer_1.useCartToggler)();
    const cleanCart = (0, cart_reducer_1.useCartCleaner)();
    const total = Object.values(actualTokens.reduce((acc, { fixPrice, paymentTokenAddress, tokenId, contractAddress }) => {
        const key = `${paymentTokenAddress}-${contractAddress}`;
        if (!acc[key]) {
            acc[key] = {
                sum: new bignumber_js_1.default(0),
                nftIds: [],
                contractAddress,
                paymentToken: tokenGetter(paymentTokenAddress),
            };
        }
        acc[key].nftIds.push(tokenId);
        acc[key].sum = acc[key].sum.plus(fixPrice);
        return acc;
    }, {}));
    const redirectToExplorer = (0, routing_hooks_1.useRedirectTo)("/explore");
    const redirectToExplorerHandler = () => {
        redirectToExplorer();
        togglePopupVisibility();
    };
    return (react_1.default.createElement(popup_1.Popup, { isOpened: true, onClose: togglePopupVisibility },
        react_1.default.createElement("div", { className: "c-cart-popup" },
            react_1.default.createElement("div", { className: "c-cart-popup__title" }, translator("cartTitle")),
            react_1.default.createElement("div", { className: "c-cart-popup__grid" },
                isLoading && (react_1.default.createElement("div", { className: "c-cart-popup__loader" },
                    react_1.default.createElement(loader_1.Loader, null))),
                cart.length === 0 && !isLoading && (react_1.default.createElement("div", { className: "c-cart-popup__empty" },
                    translator("emptyCartLabel"),
                    react_1.default.createElement(button_1.Button, { size: "small", onClick: redirectToExplorerHandler }, translator("openExplorerButton")))),
                actualTokens.map(({ token, paymentTokenAddress, fixPrice }) => {
                    var _a;
                    const previewImageUrl = token.metaUrlBase + ((_a = token.metadata) === null || _a === void 0 ? void 0 : _a.preview);
                    return (react_1.default.createElement("div", { key: token.tokenId, className: "c-cart-popup__grid-item" },
                        react_1.default.createElement("div", { onClick: () => cleanCart([token.tokenId]), className: "c-cart-popup__grid-item-delete" },
                            react_1.default.createElement(icons_1.CrossIcon, { scale: 0.9 })),
                        react_1.default.createElement(react_router_dom_1.Link, { target: "_blank", className: "g-link c-cart-popup__grid-item-info-id", to: "/nft/token" + token.tokenId },
                            react_1.default.createElement("img", { className: "c-cart-popup__grid-item-image", src: previewImageUrl })),
                        react_1.default.createElement("div", { className: "c-cart-popup__grid-item-info" },
                            react_1.default.createElement("div", { className: "c-cart-popup__grid-item-info-title" }, token.name),
                            react_1.default.createElement(currency_label_1.CurrencyLabel, { amount: fixPrice, tokenAddress: paymentTokenAddress }))));
                }),
                unavailableTokens.map(({ token }) => {
                    var _a;
                    const previewImageUrl = token.metaUrlBase + ((_a = token.metadata) === null || _a === void 0 ? void 0 : _a.preview);
                    return (react_1.default.createElement("div", { key: token.tokenId, className: "c-cart-popup__grid-item " },
                        react_1.default.createElement("div", { onClick: () => cleanCart([token.tokenId]), className: "c-cart-popup__grid-item-delete" },
                            react_1.default.createElement(icons_1.CrossIcon, { scale: 0.9 })),
                        react_1.default.createElement(react_router_dom_1.Link, { target: "_blank", className: "g-link c-cart-popup__grid-item-info-id", to: "/nft/token" + token.tokenId },
                            react_1.default.createElement("img", { className: "c-cart-popup__grid-item-image c-cart-popup__grid-item-image--sold", src: previewImageUrl })),
                        react_1.default.createElement("div", { className: "c-cart-popup__grid-item-info" },
                            react_1.default.createElement("div", { className: "c-cart-popup__grid-item-info-title" }, token.name)),
                        react_1.default.createElement("div", { className: "c-cart-popup__sold-alert" }, translator("soldLabel"))));
                }),
                hiddenTokens.map((tokenId) => {
                    return (react_1.default.createElement("div", { key: tokenId, className: "c-cart-popup__grid-item " },
                        react_1.default.createElement("div", { onClick: () => cleanCart([tokenId]), className: "c-cart-popup__grid-item-delete" },
                            react_1.default.createElement(icons_1.CrossIcon, { scale: 0.9 })),
                        react_1.default.createElement("div", { className: "c-cart-popup__missed-message" }, translator("missedTokenLabel")),
                        react_1.default.createElement("div", { className: "c-cart-popup__grid-item-info" },
                            react_1.default.createElement("div", { className: "c-cart-popup__grid-item-info-title" }, tokenId))));
                }),
                react_1.default.createElement(stub_cards_1.StubCards, { amount: 6, minWidth: "140px" })),
            react_1.default.createElement("div", { className: "c-cart-popup__grid-recipe" },
                react_1.default.createElement("div", { className: "c-cart-popup__grid-recipe-title" }, translator("recipeTitle")),
                total.map(({ paymentToken, nftIds, sum, contractAddress }) => (react_1.default.createElement(recipe_form_1.RecipeForm, { key: nftIds.join(), paymentToken: paymentToken, marketAddress: contractAddress, nftIds: nftIds, sum: sum })))))));
};
exports.CartPopup = CartPopup;
